import { type Route } from '../common';

export const flowBuilderDemoRoutes: Route[] = [
  {
    label: 'Build',
    sections: [
      {
        label: '',
        links: [
          {
            label: 'Agents',
            to: '/agents/agents',
            keywords: ['agents', 'flows', 'agent', 'flow', 'builder', 'build', 'edit agent'],
          },
          {
            label: 'Flows',
            to: '/agents/flows',
            keywords: [
              'flows',
              'flow',
              'agent',
              'flow definitions',
              'builder',
              'edit flows',
              'flow insights',
            ],
          },
          {
            label: 'Scenarios',
            to: '/fingerprint/scenarios',
            keywords: ['automations', 'scheduler', 'triggers', 'rules'],
          },
        ],
        priorityOrder: 1,
      },
    ],
  },
  {
    label: 'Operate',
    sections: [
      {
        label: '',
        links: [
          {
            label: 'Appointments',
            to: '/encounters',
            keywords: [
              'appt',
              'patients',
              'check-in',
              'checkin',
              'scheduling',
              'reschedule',
              'patient timeline',
            ],
          },
          {
            label: 'Messages',
            to: '/messaging/messages',
            keywords: [
              'broadcast',
              'sms',
              'outreach',
              'campaign',
              'texts',
              'alerts',
              'communication',
            ],
          },
          {
            label: 'Payments',
            to: '/payments/report',
            keywords: [
              'payment dashboard',
              'refunds',
              'cancel',
              'finance',
              'dispute',
              'operate',
              'billing',
            ],
          },
          {
            label: 'Payout Reports',
            to: '/payouts/report',
            keywords: ['payouts', 'deposits', 'finance', 'reconciliation', 'billing'],
          },
        ],
        priorityOrder: 2,
      },
    ],
  },
  {
    label: 'Connect',
    sections: [
      {
        label: '',
        links: [
          {
            label: 'Feeds',
            to: '/feeds',
            keywords: ['data sync', 'integrations', 'feed', 'fingerprint'],
          },
        ],
        priorityOrder: 3,
      },
    ],
  },
  {
    label: 'Templates',
    sections: [
      {
        label: '',
        links: [
          {
            label: 'Broadcast Messages',
            to: '/messaging/templates',
            keywords: ['templates', 'text', 'sms'],
          },
          {
            label: 'Documents',
            to: '/document-templates',
            keywords: ['document templates', 'notes', 'docs', 'signer'],
          },
          {
            label: 'Forms',
            to: '/previsit-form-templates',
            keywords: ['templates', 'form builder', 'primitives', 'patient', 'registration'],
          },
          {
            label: 'Notifications',
            to: '/notifications',
            keywords: [
              'templates',
              'messaging',
              'outreach',
              'schemes',
              'schedules',
              'email',
              'sms',
              'text',
              'messages',
              'voice',
              'call',
              'phone',
            ],
          },
          {
            label: 'Notes',
            to: '/note-templates',
            keywords: ['Templates'],
          },
          {
            label: 'Recommendations',
            to: '/recommendation-templates',
            keywords: ['care', 'recs', 'registration', 'patients'],
          },
        ],
        priorityOrder: 4,
      },
    ],
  },
  {
    label: 'Tools',
    sections: [
      {
        label: '',
        links: [
          {
            label: 'Web Assistants',
            to: '/assistant',
            keywords: ['embed', 'conversation', 'AI'],
          },
        ],
        priorityOrder: 5,
      },
    ],
  },
];
